import {UserTracker} from "../index.js";

const eventDics = {
	"post": "main:translate-post:click", // 글 번역
	"comment": "main:translate-comment:click", // 댓글 번역
	"reply": "main:translate-reply:click", // 대댓글 번역
}

export const TranslateTracker = () => {
	const Tracker = Object.create(UserTracker)
	Tracker.track = (eventName) => {
		const event = eventDics[eventName];
		if (!event) return;

		return Tracker.trackAction({event : event});
	}

	return Tracker;
}
